import { render, staticRenderFns } from "./UserControls.vue?vue&type=template&id=b01926a8&scoped=true"
import script from "./UserControls.vue?vue&type=script&lang=js"
export * from "./UserControls.vue?vue&type=script&lang=js"
import style0 from "./UserControls.vue?vue&type=style&index=0&id=b01926a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01926a8",
  null
  
)

export default component.exports